<template>
  <form
    @submit.prevent="$emit('submitForm')"
    class="flex h-full w-full flex-col justify-center rounded-lg bg-white p-6"
  >
    <div class="grid w-full grid-cols-1 gap-4 sm:grid-cols-2">
      <Input
        type="text"
        v-model="data.pipeline.name"
        :value="data.pipeline.name"
        :placeholder="__('Add pipeline name')"
        :label="__('Pipeline Name')"
        id="name"
        name="name"
        required
        :errors="errors.name"
      />
      <InputCareers
        id="std_title"
        v-model:value="data.pipeline.std_title"
        :errors="errors['std_title.id']"
        :label="__('Standardized job title')"
        :placeholder="__('Search here...')"
        is-new-options-allowed
        @update:value="updateStdJobTitle"
        required
      />

      <Input
        v-model="data.pipeline.start_date"
        :value="data.pipeline.start_date"
        type="date"
        id="start_date"
        :label="__('Start date and time')"
        :placeholder="__('Pick date and time')"
        :errors="errors.start_date"
        :max_date="data.pipeline.end_date"
      />
      <Input
        v-model="data.pipeline.end_date"
        :value="data.pipeline.end_date"
        type="date"
        id="end_date"
        :label="__('End date and time')"
        :placeholder="__('Pick date and time')"
        :errors="errors.end_date"
        :min_date="data.pipeline.start_date"
      />

      <div class="col-span-1 sm:col-span-2">
        <Input
          v-model="data.pipeline.open_positions"
          :value="data.pipeline.open_positions"
          :placeholder="__('Add open positions')"
          :label="__('Opened positions')"
          type="number"
          onkeydown=""
          :errors="errors.open_positions"
          class="w-full"
        />
      </div>

      <div class="col-span-1 flex flex-col gap-4 sm:col-span-2 sm:flex-row">
        <div class="w-full">
          <label class="mb-2 block text-sm text-[#58585E]"
            >{{ __('Salary Type') }}
          </label>
          <FormSingleselect
            v-model="data.pipeline.salary.type"
            :values="data.options.salary.type"
            id="end_date_time"
            :label="__('Salary Type')"
            :placeholder="__('Monthly')"
            :clearable="true"
            @clear="data.pipeline.salaty.type = null"
            type="static"
            :errors="errors['salary.type']"
          />
        </div>

        <Input
          v-model="data.pipeline.salary.wage"
          :value="data.pipeline.salary.wage"
          :placeholder="__('Add wage')"
          :label="__('Wage')"
          type="number"
          :errors="errors['salary.wage']"
          class="w-full"
        />

        <div class="w-full">
          <label class="mb-2 block text-sm text-[#58585E]"
            >{{ __('Currency') }}
          </label>
          <FormSingleselect
            id="currency"
            v-model="data.pipeline.salary.currency"
            :values="data.options.salary.currency"
            :clearable="true"
            @clear="data.pipeline.salary.currency = null"
            type="static"
            :errors="errors?.salary?.currency"
            :placeholder="'$'"
            class="flex-1"
          />
        </div>
      </div>
      <div class="">
        <label class="mb-2 block text-sm text-[#58585E]"
          >{{ __('Project Status') }} *</label
        >
        <FormSingleselect
          v-model="data.pipeline.project_status"
          :values="data.options.project_status"
          :clearable="true"
          @clear="data.pipeline.project_status = null"
          type="static"
          :errors="errors.project_status"
          required
        />
      </div>

      <div class="">
        <label class="mb-2 block text-sm text-[#58585E]"
          >{{ __('Collaborators') }}
        </label>
        <FormMultiselect
          v-model="data.pipeline.recruiters"
          :values="data.options.recruiters"
          :clearable="true"
          :multiple="true"
          type="static"
          class="mt-2"
          :errors="errors.recruiters"
        />
      </div>

      <div class="col-span-1 sm:col-span-2">
        <InputTextarea
          id="pipeline_description"
          v-model:value="data.pipeline.pipeline_description"
          :label="__('Pipeline Description')"
          :placeholder="__('Here you can add more details about the pipeline')"
          :errors="errors.pipeline_description"
        >
        </InputTextarea>
      </div>
    </div>

    <div class="mt-11 flex flex-row items-center justify-center gap-4">
      <Button
        @click="goBack()"
        class="flex items-center gap-1.5"
        variant="ghost"
      >
        <span>
          {{ __('Cancel') }}
        </span>
      </Button>
      <Button class="flex items-center gap-1.5" type="submit">
        <span>
          {{ submitText }}
        </span>
      </Button>
    </div>
  </form>
</template>

<script setup>
  import axios from 'axios';
  import { ref } from 'vue';
  import { Button } from '../../../../components/block/button';
  import { __ } from '../../../../helpers';

  import { useToast } from 'vue-toastification';
  import InputCareers from '../../../../components/form/input-careers/input-careers.vue';
  import { InputTextarea } from '../../../../components/form/input-textarea';

  import {
    FormMultiselect,
    FormSingleselect
  } from '../../../../components/global';
  import Input from '../../../../components/global/Form/Input.vue';

  const toast = useToast();

  const props = defineProps({
    data: Object,
    errors: Object,
    submitText: String
  });

  async function updateStdJobTitle(value) {
    if (!value) {
      return;
    }
    await stdHasAttributes(value);
  }

  const goBack = () => {
    window.history.back();
  };

  const hasAttributes = ref(false);
  const selectedAttribute = ref();

  async function stdHasAttributes(stdId) {
    try {
      const result = await axios.post(route('redesign.std.has.attributes'), {
        std_id: stdId
      });
      hasAttributes.value = result.data;
      selectedAttribute.value = stdId;
    } catch (e) {
      toast.error(__('An error occurred, please try again!'));
    }
  }
</script>
